import React from 'react'
import './School.css'

import iconHome from '../../assets/icons/home-icon.png';
import iconEsmia from '../../assets/icons/ESMIA.png';
import iconODC from '../../assets/icons/odc.png';

import home from '../../assets/images/desktop.jpg';
import esmia from '../../assets/images/esmia.jpg';
import odc from '../../assets/images/odc.jpeg';

import SchoolCards from './SchoolCards';

export default function School() {
  return (
    <div className="school-container">
        <div className='school-title'>
            <h2>Where did I learn to code ?</h2>
        </div>
        <div className='schools'>
            <SchoolCards 
                image= {home}
                place= "Home"
                caption= "The place where I gained the most knowledge about programming languages, libraries like ReactJS, frameworks such as Symfony, and more."
                logo={iconHome}
                backgroundColor= "#1163e2bf"
                altText="Home programming learning environment"
                logoAltText="Home logo"
            />
            <SchoolCards 
                image= {esmia}
                place= "ESMIA"
                caption= "At ESMIA, I learned a variety of things, including the basics of coding, business promotion, digital marketing fundamentals, principles of management, dashboard development (e.g., defining KPIs), data analysis techniques (e.g., AFC, CAH, ACP, ...), and an introduction to AI."
                logo= {iconEsmia}
                backgroundColor= "#f1e20bbf"
                color= "#041f60"
                altText="ESMIA campus"
                logoAltText="ESMIA logo"
            />
            <SchoolCards 
                image= {odc}
                place= "ODC"
                caption= "I acquired skills in web development at ODC with HTML5, CSS3, JavaScript, PHP, MySQL, Agile methodology, and Git."
                logo= {iconODC}
                backgroundColor= "#f19407bf"
                color= "#0a0a0a"
                altText="ODC campus"
                logoAltText="ODC logo"
            />
        </div>
    </div>
  );
}
